
const env = process.env.VUE_APP_ENV || 'development' 
const domainMap = {
  // 开发环境
  development: {
    api:     process.env.VUE_APP_BASE_API ||  'http://192.168.0.10:18080' , 
    server:    process.env.VUE_APP_SERVER_DOMAIN || 'http://192.168.0.10:18080'  ,  
    ws: 'wss://box.leboparkingtest.com/prod-api' || 'ws://192.168.0.21:18080' 
  },
  // 测试环境
  test: {
    api:   process.env.VUE_APP_BASE_API,  
    server:   process.env.VUE_APP_SERVER_DOMAIN,
    ws: 'wss://box.leboparkingtest.com/prod-api'
  },
  // 生产环境
  production: {
    api:  process.env.VUE_APP_BASE_API,  
    server:   process.env.VUE_APP_SERVER_DOMAIN,
    ws: 'wss://box.lebozntc.com/prod-api'
  }
}

export const currentDomain = domainMap[env]
console.log('当前环境：', process.env.VUE_APP_ENV , env)
console.log('当前WS地址：', currentDomain.ws)

// 通用方法：拼接完整URL（比如图片/文件地址）
export const getFullUrl = (path) => {
  // 如果是绝对路径，直接返回
  if (path && path.startsWith('http')) return path
  // 拼接当前环境的服务器域名 + 路径（处理路径开头的/）
  const finalPath = path?.startsWith('/') ? path : `/${path || ''}`
  return `${currentDomain.server}${finalPath}`
}